import { LuChevronRight } from 'react-icons/lu'
import { Flex, Text } from '@chakra-ui/react'
import { ProductCategory } from '@leid/api-products'
import Link from 'next/link'

import { getCategoryName, getCategoryURL } from '../utils/categories'

type Props = {
  category: ProductCategory
  hasChildren?: boolean
  allCategories: ProductCategory[]
  onClick: () => void
}

const CategoryMenuItemLink = ({ category, allCategories, hasChildren, onClick }: Props): JSX.Element => {
  const url = getCategoryURL(category, allCategories)

  return (
    <Link href={url} passHref style={{ width: '100%', minWidth: '361px' }} onClick={onClick}>
      <Flex
        alignItems="center"
        flexDirection="row"
        width="100%"
        gap={6}
        style={{
          paddingLeft: '24px',
          paddingRight: '24px',
          paddingTop: '10px',
          paddingBottom: '10px',
          cursor: 'pointer',
        }}
      >
        {category.imageUrl && (
          <>
            <Flex height="28px" width="28px" alignItems="center">
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img src={category.imageUrl} alt="" width="28px" height="28px" style={{ objectFit: 'contain' }} />
            </Flex>
          </>
        )}
        <span style={{ textAlign: 'start', margin: 'auto', marginLeft: 0 }}>
          <Text fontSize={{ base: 'md', lg: 'sm' }} color="black">
            {getCategoryName(category)}
          </Text>
        </span>
        {hasChildren && (
          <span style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <LuChevronRight size={24} />
          </span>
        )}
      </Flex>
    </Link>
  )
}

export default CategoryMenuItemLink
